// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-campaigns-container {
  margin-left: 4.36rem;
  margin-right: 4.36rem;
}
.dashboard-saved-campaigns {
  margin-top: 3rem;
  width: 96vw;
}
.search-input-mycampaigns {
  padding-right: 0rem;
}
.campaigns-table-container {
  height: 70vh;
  overflow: scroll;
}
.campaign {
  color: var(--Colors-Text-500, #0a0f0d);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.campaign-search {
  margin-bottom: 10px;
}

.cart-btn-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.not-clickable {
  opacity: 0.6;
  cursor: not-allowed;
  color: #808080;
  pointer-events: none;
}

.my-campaign {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: Montserrat;
  font-size: var(--Font-Font-Size-h5, 23px);
}

.campaign-utility {
  margin-top: 27px;
  margin-right: 32px;
}

.search-input {
  width: 583px;
}

.campaign-search {
  width: 170px;
  height: 50px;
  margin-left: 75px;
}

.search-campaigns {
  padding-right: 0 !important;
}

.new-campaign {
  height: 50px;
  align-self: center;
}

.all-campaigns .table-content .ant-table-wrapper .ant-table-container {
  position: relative;
  height: 642px;
  overflow-y: scroll;
}
.all-campaigns .ant-table-body tr.ant-table-row {
  cursor: pointer;
}

.ant-table-wrapper .ant-table-thead > tr > th {
  font-family: Roboto;
  color: #fff;
  background-color: #000;
}

.ant-table-wrapper .ant-table-tbody > tr > td {
  font-family: Roboto !important;
  font-weight: 500;
  font-style: Semi Bold !important;
  font-size: 14px !important;
  line-height: 17.5px !important;
  letter-spacing: 0px !important;
  color: #101828 !important;
}

.ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {
  background: #000;
}

.ant-table-wrapper .ant-table-thead th.ant-table-column-sort {
  background: #000;
}

.ant-table-wrapper td.ant-table-column-sort {
  background: #fff;
}

.group-new-campaign {
  width: 250px;
}

.ellipsis-btn {
  height: 40px;
  width: 40px;
  border: none;
  border-radius: 39px;
}
.campaigns-table .ant-table-thead > tr > th:not(:first-child) {
  text-align: left !important;
}
.rename-draw-header {
  font-family: Roboto;
  color: #000;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.rename-draw-container {
  margin: 40px 20px 0 30px;
}

.handle-rename-cancel-btn {
  display: flex;
  width: 177px;
  height: 40px;
  padding: 8px 34px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #f0f0f0;
  border: none;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.handle-rename-save-btn {
  border-radius: 5px;
  background: var(--Colors-Primary-500, #d2042d);
  display: flex;
  width: 177px;
  height: 40px;
  padding: 8px 34px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border: none;
  color: var(--Colors-Text-500, #fff);

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.search-text {
  color: #fff;
}

.campaign-input-field {
  height: 3.125rem;
  padding: 0.625rem 1.25rem !important;
  align-items: center;
  margin-top: 0;
  font-size: 1rem;
  border-radius: 0.3125rem !important;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;
  background: #fcfcfc !important;
}

.campaign-segments {
  font-family: Roboto;
  color: #000;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  height: 51px;
}

.selectedCount {
  font-family: Roboto;
  background: #f5f5f5;
  padding: 8px;
  margin-left: 5px;
}

.unSelectedCount {
  padding: 8px;
  margin-left: 14px;
  background: #fff;
}

.ant-segmented-item-label {
  padding: 8px 15px !important;
  align-items: center;
  width: auto;
}

.segment-container .ant-segmented .ant-segmented-item-focused {
  outline: unset;
  outline-offset: 1px;
  transition:
    outline-offset 0s,
    outline 0s;
}

.campaign-card {
  display: flex;
  justify-content: center;
}
.campaign-id-button {
  color: #d2042d !important;
  font-size: 14px;
  font-family: Roboto;
  font-weight: 500;
  text-decoration: underline;
}

.campaigns-header {
  position: sticky;
}

.ant-table table {
  font-size: 16px;
}

.campaigns-table {
  color: #fff;
  width: 100%;
  height: 141px;
  top: 275px;
  left: 88px;
  gap: 14px;
  border-radius: 10px 0px 0px 0px;
  opacity: 0px;
}

.segment-container .ant-segmented.ant-segmented-sm .ant-segmented-item {
  border-radius: 10px;
  width: 190px;
}

.campaigns-table .ant-checkbox-inner {
  width: 17px !important;
  height: 17px !important;
  left: 25px;
  top: 18.5px;
}

.view-campaigns-table .ant-table-thead .ant-table-cell {
  font-family: Roboto;
  background-color: #0a0f0d !important;
  font-weight: 600;
  line-height: 18.75px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #fff !important;
}

.my-campaigns-container .ant-divider-horizontal {
  display: flex;
  clear: both;
  width: 100%;
  min-width: 100%;
  margin: 2px 0;
}

.ellipse-container.rotate-ellipsis {
  width: 60px;
  height: 60px;
}

.campaigns-table a {
  color: rgb(12, 12, 12);
  text-decoration: none;
  background-color: transparent;
  font-size: 16px;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
  -webkit-text-decoration-skip: objects;
}

.action-item {
  font-size: 16px !important;
  padding-right: 5px;
  font-family: Roboto;
}

.ellipsis-btn {
  display: flex;
  height: 40px;
  justify-content: center;
  border: none;
  align-items: center;
  background-color: #fff;
}

.ellipsis-btn .ant-btn-color-default {
  box-shadow: none;
}

.ant-table-column-sorter {
  color: #fff !important;
}

.ant-table-column-sorters {
  display: inline !important;
}

.ant-table-column-sorter-inner {
  flex-direction: row !important;
}

.action-item-sect {
  display: flex;
  align-items: center;
}

.campaign-action-items .ant-menu-light .ant-menu-item-selected {
  color: #fff;
  display: flex;
  align-items: center;
}

.campaign-action-items .ant-menu-light .ant-menu-item-selected {
  background-color: #d2042d;
  display: flex;
  align-items: center;
}

.campaign-action-items .ant-menu-light.ant-menu-root.ant-menu-vertical {
  border-inline-end: none;
}

.campaign-action-items
  .ant-menu-light
  .ant-menu-item:not(ant-menu-item-disabled)
  .ant-menu-item:not(.ant-menu-item-selected):not(
    .ant-menu-submenu-selected
  ):hover {
  color: #fff;
  display: flex;
  align-items: center;
}

.campaign-action-items
  .ant-menu-light:not(.ant-menu-horizontal)
  .ant-menu-item:not(.ant-menu-item-selected):hover {
  background-color: #d2042d;
  display: flex;
  align-items: center;
}

.action-items-text {
  font-family: Roboto;
  font-size: 14px;
  align-items: center;
  display: flex;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  gap: 7px !important;
}
.campaign-action-items .ant-menu-item-disabled .action-icons {
  cursor: not-allowed;
}
.campaign-action-items .ant-menu-vertical > .ant-menu-item {
  display: flex;
  align-items: center !important;
}
.rotate-ellipsis-css {
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000;
  font-family: Roboto;
}

.campaign-div {
  height: 63vh;
  overflow-y: scroll;
}

.campaign-row {
  flex-flow: nowrap;
  gap: 0.5rem;
}

.campaign-drawer {
  padding-left: 35px;
  padding-top: 70px;
}

.campaign-drawer-actions {
  font-family: Roboto;
  font-size: 16px;
  font-weight: 600;
}

.campaign-action-buttons {
  font-family: Roboto;
  flex-flow: nowrap;
  gap: 0.5rem;
}

.fixed-addto-create-campaign-btn-card-col {
  text-align: center;
  margin-top: 10px;
}
.col-for-maintain-center-warning-count {
  display: flex;
  gap: 10px;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.text-center-vertically {
  display: flex;
  align-items: center;
}
.campaign-purchase-sold-icon {
  cursor: pointer;
}
.campaign-purchase-sold-icon-version {
  margin-right: 5px;
}
.custom-tooltip-inner {
  color: rgb(12, 12, 12);
  text-decoration: none;
  background-color: transparent;
  font-size: 16px;
  outline: none;
  cursor: pointer;
  transition: color 0.3s;
}
.multiple-campaigns-cart-button {
  width: 120px;
  height: 45px;
  gap: 8px;
  border-radius: 5px;
  background: var(--Colors-Primary-500, #d2042d);
  border-color: #d2042d !important;
}
.multiple-campaigns-cart-button:hover {
  background: var(--Colors-Primary-500, #d2042d) !important;
}
.multiple-campaigns-cart-button-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #ffffff;
}
.segements-campaigns-actions-row {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
}

.campaigns-table .ant-table-tbody > tr {
  cursor: pointer;
}

.campaigns-table.ant-table-wrapper
  .ant-table-tbody
  .ant-table-row.ant-table-row-selected
  > .ant-table-cell {
  background: #fff !important;
}
.campaigns-table.ant-table-row.ant-table-row-selected
  td
  .ant-checkbox-disabled {
  background-color: #f5f5f5 !important;
}

.campaigns-table.ant-checkbox-disabled .ant-checkbox-inner {
  background: rgba(0, 0, 0, 0.04) !important;
  border-color: #d9d9d9 !important;
}

@media (max-width: 1440px) {
  .search-input {
    width: 458px !important;
  }

  .campaign-utility {
    margin-top: 14px;
    margin-right: 30px !important;
  }
  .campaign-segments {
    color: #000;
    font-size: var(--Font-Font-Size-p, 16px);
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    height: 51px;
    width: 1100px;
    overflow-x: scroll;
  }
  .segment-container .ant-segmented.ant-segmented-sm .ant-segmented-item {
    border-radius: 10px;
    width: 200px;
  }
  .ant-segmented.ant-segmented-sm .ant-segmented-item-label {
    min-height: 20px;
    line-height: 20px;
    width: 200px;
    padding: 0 7px;
  }
}

@media (max-width: 1024px) {
  .my-campaigns-container {
    margin-inline: 30px;
  }

  .campaigns-table {
    color: #fff;
    width: 1600px;
    height: 141px;
    top: 275px;
    left: 88px;
    gap: 14px;
    border-radius: 10px 0px 0px 0px;
    opacity: 0px;
  }

  .my-campaigns-container .search-input {
    width: 100% !important;
  }
  .campaign-search {
    width: 170px;
    height: 50px;
    margin-left: 0px;
  }

  .quantity {
    font-family: Roboto;
    color: #000;
    font-size: var(--Font-Font-Size-small, 13px);
    font-weight: 500;
  }

  .campaign-utility {
    margin-top: 17px;
    margin-right: 0px !important;
  }

  .segment-container {
    width: 1000px !important;
    overflow-x: scroll;
  }

  .ant-table table {
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .my-campaigns-container {
    margin-inline: 30px;
  }

  .my-campaigns-container .search-input {
    width: 100% !important;
    border: none;
  }

  .quantity {
    font-family: Roboto;
    color: #000;
    font-size: var(--Font-Font-Size-small, 13px);
    font-weight: 500;
    /* margin-left: 49%; */
  }
  .warning-icon-for-product-sold {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .mobile-dashboard-icons-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .campaign-cost {
    font-family: Roboto;
    font-size: 19px;
    display: flex;
    justify-content: end;
    color: var(--Colors-Text-500, #0a0f0d);
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .ellipsis-mobile-btn {
    display: flex;
    width: 51px;
    height: 50px;
    padding: 3px 7px;
    justify-content: center;
    align-items: center;
    border: none;
    border-radius: 5px;
    background: #f5f5f5;
  }

  .mobile-campaign-card {
    margin-top: 22px;
  }

  .product-align {
    text-align: end;
  }
  .segment-container .ant-segmented.ant-segmented-sm .ant-segmented-item {
    border-radius: 10px;
    width: 210px;
  }
  .ant-segmented.ant-segmented-sm .ant-segmented-item-label {
    min-height: 20px;
    line-height: 20px;
    width: 200px;
    padding: 0 7px;
  }
  .number-of-products-version-col {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-content: flex-end;
    justify-content: center;
    align-items: flex-start;
  }
}

@media (max-width: 576px) {
  .my-campaign {
    font-size: 19px;
    margin: 25px 0 22px 18px;
  }

  .ellipse-container .rotate-ellipsis {
    transform: rotate(90deg) !important;
    width: 40px;
    height: 40px;
  }

  .my-campaigns-container {
    margin-inline: 16px;
  }

  .action-item {
    color: #d2042d !important;
  }

  .ellipsis-btn {
    display: flex;
    height: 40px;
    padding: 5px 3px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .ant-table-column-sorter {
    color: #fff !important;
  }

  .ant-table-column-sorters {
    display: inline !important;
  }

  .ant-table-column-sorter-inner {
    flex-direction: row !important;
  }

  @media (max-width: 576px) {
    .my-campaign {
      font-size: 19px;
      margin: 25px 0 22px 18px;
    }

    .search-input {
      width: 100%;
    }

    .campaign-search {
      margin-top: 22px;
    }

    .my-campaigns-container {
      margin-left: 18px;
    }

    .campaign-utility {
      margin-top: 22px;
      margin-right: 18px;
    }

    .mobile-card {
      margin-top: 17px;
      margin-left: 30px;
    }
    .campaign-button {
      width: 358px;
      height: 50px;
    }

    .button-container {
      display: flex;
      width: 430px;
      padding: 25px 18px 33px 18px;
      justify-content: center;
      align-items: center;
      background: #fff;
      box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.21);
    }

    .new-campaign {
      position: "sticky";
      bottom: "0";
    }

    .segment-container {
      display: flex;
      overflow-x: auto;
      white-space: nowrap;
      max-width: 100%;
      width: 600px;
      overflow-x: scroll;
    }

    .mobile-campaign-card {
      margin-top: 22px;
    }

    .campaign-cost {
      font-family: Roboto;
      font-size: 19px;
      display: flex;
      justify-content: end;
      color: var(--Colors-Text-500, #0a0f0d);
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    .detail-block {
      display: flex;
      justify-content: space-between;
    }

    .mobile-campaign-card .detail-label {
      color: #8e9190;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-top: 30px;
    }

    .product-align {
      text-align: end;
    }

    .quantity {
      font-family: Roboto;
      margin-left: 29%;
    }

    .dates {
      color: #000;
    }

    .add-cart-button {
      font-family: Roboto;
      display: flex;
      color: #fff !important;
      width: 288px;
      height: 50px;
      padding: 8px 20px;
      justify-content: center;
      align-items: center;
      border-radius: 10px;
    }
  }

  .my-campaigns-container .fixed-addto-create-campaign-btn-card {
    position: fixed;
    display: flex;
    width: 380px;
    padding: 15px 18px 13px 18px;
    justify-content: center;
    align-items: center;
    box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.21);
  }

  .my-campaigns-container .new-campaign-creation {
    display: flex;
    width: 364px;
    height: 50px;
    border-radius: 5px;
    background: #d2042d;
    padding: 8px 20px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .my-campaigns-container
    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: #f5f5f5;
    border: none;
    height: 50px;
    margin-top: 1rem;
    color: rgb(12, 12, 12);
  }
}
@media (max-width: 768px) {
  .alignment-button-class {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }
}
@media (max-width: 430px) {
  .detail-block .product-availability {
    font-family: Roboto;
    font-size: 14px;
  }
  .fixed-addto-create-campaign-btn-card
    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: #f5f5f5;
    border: none;
    height: 50px;
    color: rgb(12, 12, 12);
  }

  .add-cart-button {
    display: flex;
    width: 275px;
    height: 50px;
    padding: 8px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
  }

  .quantity {
    font-family: Roboto;
    margin-left: 15% !important;
  }
  .product-sold-status-row {
    display: flex;
    align-items: center !important;
  }
  .campaign-purchase-sold-icon-version {
    margin-right: 5px;
    font-size: 10px;
    width: 20px !important;
    height: 20px !important;
  }
}
@media (max-width: 400px) {
  .add-cart-button {
    width: 233px;
  }
  .detail-block .product-availability {
    font-family: Roboto;
    font-size: 13px;
  }
}

@media (max-width: 380px) {
  .add-cart-button {
    display: flex;
    width: 200px;
    height: 50px;
    padding: 8px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
  }
  .handle-rename-cancel-btn {
    display: flex;
    width: 130px;
    height: 40px;
  }
  .handle-rename-save-btn {
    display: flex;
    width: 130px;
    height: 40px;
    background-color: #d2042d;
  }
  .mobile-campaign-card .detail-label {
    color: var(--Colors-Text-200, #8e9190);
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  .quantity {
    font-family: Roboto;
    margin-left: 30% !important;
  }

  .my-campaigns-container .fixed-addto-create-campaign-btn-card {
    position: fixed;
    display: flex;
    width: 350px;
    padding: 15px 18px 13px 18px;
    justify-content: center;
    align-items: center;
    box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.21);
  }

  .my-campaigns-container
    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: #f5f5f5;
    border: none;
    height: 50px;
    margin-top: 1rem;
    color: rgb(12, 12, 12);
  }

  .my-campaigns-container .new-campaign-creation {
    display: flex;
    width: 364px;
    height: 50px;
    border-radius: 5px;
    background: #d2042d;
    padding: 8px 20px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  .fixed-addto-create-campaign-btn-card
    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {
    background-color: #f5f5f5;
    border: none;
    height: 50px;
    color: rgb(12, 12, 12);
  }
}
@media (width <= 330px) {
  .share-campaign-model-warn .share-campaign-text {
    width: 100%;
    flex-shrink: 0;
    color: var(--Colors-Primary-500, #d2042d);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
  .share-camapign-model-header {
    color: var(--Colors-Text-500, #0a0f0d);
    font-family: "Montserrat";
    font-size: var(--Font-Font-Size-h5, 20px);
    padding-bottom: 30px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/mycampaigns/MyCampaignsPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,mCAAmC;;EAEnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,mEAAmE;EACnE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB;;cAEY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,UAAU;EACV,UAAU;EACV,SAAS;EACT,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;EAClC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;;;EAME,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,8CAA8C;EAC9C,gCAAgC;AAClC;AACA;EACE,yDAAyD;AAC3D;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,2BAA2B;AAC7B;AACA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,cAAc;EAChB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,UAAU;IACV,UAAU;IACV,SAAS;IACT,+BAA+B;IAC/B,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,4CAA4C;IAC5C,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,4CAA4C;IAC5C,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,oBAAoB;IACpB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,cAAc;EAChB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;IACf,wBAAwB;EAC1B;;EAEA;IACE,mCAAmC;IACnC,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE;MACE,eAAe;MACf,wBAAwB;IAC1B;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,iBAAiB;IACnB;IACA;MACE,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,aAAa;MACb,YAAY;MACZ,4BAA4B;MAC5B,uBAAuB;MACvB,mBAAmB;MACnB,gBAAgB;MAChB,iDAAiD;IACnD;;IAEA;MACE,kBAAkB;MAClB,WAAW;IACb;;IAEA;MACE,aAAa;MACb,gBAAgB;MAChB,mBAAmB;MACnB,eAAe;MACf,YAAY;MACZ,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,mBAAmB;MACnB,eAAe;MACf,aAAa;MACb,oBAAoB;MACpB,sCAAsC;MACtC,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,8BAA8B;IAChC;;IAEA;MACE,cAAc;MACd,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,mBAAmB;MACnB,gBAAgB;IAClB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,mBAAmB;MACnB,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,YAAY;MACZ,iBAAiB;MACjB,uBAAuB;MACvB,mBAAmB;MACnB,mBAAmB;IACrB;EACF;;EAEA;IACE,eAAe;IACf,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,iDAAiD;EACnD;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;;EAEA;;IAEE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;EACV;AACF;AACA;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;EACA;;IAEE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;EACd;EACA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,aAAa;IACb,YAAY;IACZ,4BAA4B;IAC5B,uBAAuB;IACvB,mBAAmB;IACnB,iDAAiD;EACnD;;EAEA;;IAEE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;EAChB;;EAEA;;IAEE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,sBAAsB;EACxB;AACF;AACA;EACE;IACE,WAAW;IACX,cAAc;IACd,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,sCAAsC;IACtC,yBAAyB;IACzB,yCAAyC;IACzC,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".my-campaigns-container {\n  margin-left: 4.36rem;\n  margin-right: 4.36rem;\n}\n.dashboard-saved-campaigns {\n  margin-top: 3rem;\n  width: 96vw;\n}\n.search-input-mycampaigns {\n  padding-right: 0rem;\n}\n.campaigns-table-container {\n  height: 70vh;\n  overflow: scroll;\n}\n.campaign {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.campaign-search {\n  margin-bottom: 10px;\n}\n\n.cart-btn-container {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.not-clickable {\n  opacity: 0.6;\n  cursor: not-allowed;\n  color: #808080;\n  pointer-events: none;\n}\n\n.my-campaign {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-family: Montserrat;\n  font-size: var(--Font-Font-Size-h5, 23px);\n}\n\n.campaign-utility {\n  margin-top: 27px;\n  margin-right: 32px;\n}\n\n.search-input {\n  width: 583px;\n}\n\n.campaign-search {\n  width: 170px;\n  height: 50px;\n  margin-left: 75px;\n}\n\n.search-campaigns {\n  padding-right: 0 !important;\n}\n\n.new-campaign {\n  height: 50px;\n  align-self: center;\n}\n\n.all-campaigns .table-content .ant-table-wrapper .ant-table-container {\n  position: relative;\n  height: 642px;\n  overflow-y: scroll;\n}\n.all-campaigns .ant-table-body tr.ant-table-row {\n  cursor: pointer;\n}\n\n.ant-table-wrapper .ant-table-thead > tr > th {\n  font-family: Roboto;\n  color: #fff;\n  background-color: #000;\n}\n\n.ant-table-wrapper .ant-table-tbody > tr > td {\n  font-family: Roboto !important;\n  font-weight: 500;\n  font-style: Semi Bold !important;\n  font-size: 14px !important;\n  line-height: 17.5px !important;\n  letter-spacing: 0px !important;\n  color: #101828 !important;\n}\n\n.ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {\n  background: #000;\n}\n\n.ant-table-wrapper .ant-table-thead th.ant-table-column-sort {\n  background: #000;\n}\n\n.ant-table-wrapper td.ant-table-column-sort {\n  background: #fff;\n}\n\n.group-new-campaign {\n  width: 250px;\n}\n\n.ellipsis-btn {\n  height: 40px;\n  width: 40px;\n  border: none;\n  border-radius: 39px;\n}\n.campaigns-table .ant-table-thead > tr > th:not(:first-child) {\n  text-align: left !important;\n}\n.rename-draw-header {\n  font-family: Roboto;\n  color: #000;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.rename-draw-container {\n  margin: 40px 20px 0 30px;\n}\n\n.handle-rename-cancel-btn {\n  display: flex;\n  width: 177px;\n  height: 40px;\n  padding: 8px 34px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #f0f0f0;\n  border: none;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.handle-rename-save-btn {\n  border-radius: 5px;\n  background: var(--Colors-Primary-500, #d2042d);\n  display: flex;\n  width: 177px;\n  height: 40px;\n  padding: 8px 34px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border: none;\n  color: var(--Colors-Text-500, #fff);\n\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.search-text {\n  color: #fff;\n}\n\n.campaign-input-field {\n  height: 3.125rem;\n  padding: 0.625rem 1.25rem !important;\n  align-items: center;\n  margin-top: 0;\n  font-size: 1rem;\n  border-radius: 0.3125rem !important;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d) !important;\n  background: #fcfcfc !important;\n}\n\n.campaign-segments {\n  font-family: Roboto;\n  color: #000;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  height: 51px;\n}\n\n.selectedCount {\n  font-family: Roboto;\n  background: #f5f5f5;\n  padding: 8px;\n  margin-left: 5px;\n}\n\n.unSelectedCount {\n  padding: 8px;\n  margin-left: 14px;\n  background: #fff;\n}\n\n.ant-segmented-item-label {\n  padding: 8px 15px !important;\n  align-items: center;\n  width: auto;\n}\n\n.segment-container .ant-segmented .ant-segmented-item-focused {\n  outline: unset;\n  outline-offset: 1px;\n  transition:\n    outline-offset 0s,\n    outline 0s;\n}\n\n.campaign-card {\n  display: flex;\n  justify-content: center;\n}\n.campaign-id-button {\n  color: #d2042d !important;\n  font-size: 14px;\n  font-family: Roboto;\n  font-weight: 500;\n  text-decoration: underline;\n}\n\n.campaigns-header {\n  position: sticky;\n}\n\n.ant-table table {\n  font-size: 16px;\n}\n\n.campaigns-table {\n  color: #fff;\n  width: 100%;\n  height: 141px;\n  top: 275px;\n  left: 88px;\n  gap: 14px;\n  border-radius: 10px 0px 0px 0px;\n  opacity: 0px;\n}\n\n.segment-container .ant-segmented.ant-segmented-sm .ant-segmented-item {\n  border-radius: 10px;\n  width: 190px;\n}\n\n.campaigns-table .ant-checkbox-inner {\n  width: 17px !important;\n  height: 17px !important;\n  left: 25px;\n  top: 18.5px;\n}\n\n.view-campaigns-table .ant-table-thead .ant-table-cell {\n  font-family: Roboto;\n  background-color: #0a0f0d !important;\n  font-weight: 600;\n  line-height: 18.75px;\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  color: #fff !important;\n}\n\n.my-campaigns-container .ant-divider-horizontal {\n  display: flex;\n  clear: both;\n  width: 100%;\n  min-width: 100%;\n  margin: 2px 0;\n}\n\n.ellipse-container.rotate-ellipsis {\n  width: 60px;\n  height: 60px;\n}\n\n.campaigns-table a {\n  color: rgb(12, 12, 12);\n  text-decoration: none;\n  background-color: transparent;\n  font-size: 16px;\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n  -webkit-text-decoration-skip: objects;\n}\n\n.action-item {\n  font-size: 16px !important;\n  padding-right: 5px;\n  font-family: Roboto;\n}\n\n.ellipsis-btn {\n  display: flex;\n  height: 40px;\n  justify-content: center;\n  border: none;\n  align-items: center;\n  background-color: #fff;\n}\n\n.ellipsis-btn .ant-btn-color-default {\n  box-shadow: none;\n}\n\n.ant-table-column-sorter {\n  color: #fff !important;\n}\n\n.ant-table-column-sorters {\n  display: inline !important;\n}\n\n.ant-table-column-sorter-inner {\n  flex-direction: row !important;\n}\n\n.action-item-sect {\n  display: flex;\n  align-items: center;\n}\n\n.campaign-action-items .ant-menu-light .ant-menu-item-selected {\n  color: #fff;\n  display: flex;\n  align-items: center;\n}\n\n.campaign-action-items .ant-menu-light .ant-menu-item-selected {\n  background-color: #d2042d;\n  display: flex;\n  align-items: center;\n}\n\n.campaign-action-items .ant-menu-light.ant-menu-root.ant-menu-vertical {\n  border-inline-end: none;\n}\n\n.campaign-action-items\n  .ant-menu-light\n  .ant-menu-item:not(ant-menu-item-disabled)\n  .ant-menu-item:not(.ant-menu-item-selected):not(\n    .ant-menu-submenu-selected\n  ):hover {\n  color: #fff;\n  display: flex;\n  align-items: center;\n}\n\n.campaign-action-items\n  .ant-menu-light:not(.ant-menu-horizontal)\n  .ant-menu-item:not(.ant-menu-item-selected):hover {\n  background-color: #d2042d;\n  display: flex;\n  align-items: center;\n}\n\n.action-items-text {\n  font-family: Roboto;\n  font-size: 14px;\n  align-items: center;\n  display: flex;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  gap: 7px !important;\n}\n.campaign-action-items .ant-menu-item-disabled .action-icons {\n  cursor: not-allowed;\n}\n.campaign-action-items .ant-menu-vertical > .ant-menu-item {\n  display: flex;\n  align-items: center !important;\n}\n.rotate-ellipsis-css {\n  font-size: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #000;\n  font-family: Roboto;\n}\n\n.campaign-div {\n  height: 63vh;\n  overflow-y: scroll;\n}\n\n.campaign-row {\n  flex-flow: nowrap;\n  gap: 0.5rem;\n}\n\n.campaign-drawer {\n  padding-left: 35px;\n  padding-top: 70px;\n}\n\n.campaign-drawer-actions {\n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.campaign-action-buttons {\n  font-family: Roboto;\n  flex-flow: nowrap;\n  gap: 0.5rem;\n}\n\n.fixed-addto-create-campaign-btn-card-col {\n  text-align: center;\n  margin-top: 10px;\n}\n.col-for-maintain-center-warning-count {\n  display: flex;\n  gap: 10px;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.text-center-vertically {\n  display: flex;\n  align-items: center;\n}\n.campaign-purchase-sold-icon {\n  cursor: pointer;\n}\n.campaign-purchase-sold-icon-version {\n  margin-right: 5px;\n}\n.custom-tooltip-inner {\n  color: rgb(12, 12, 12);\n  text-decoration: none;\n  background-color: transparent;\n  font-size: 16px;\n  outline: none;\n  cursor: pointer;\n  transition: color 0.3s;\n}\n.multiple-campaigns-cart-button {\n  width: 120px;\n  height: 45px;\n  gap: 8px;\n  border-radius: 5px;\n  background: var(--Colors-Primary-500, #d2042d);\n  border-color: #d2042d !important;\n}\n.multiple-campaigns-cart-button:hover {\n  background: var(--Colors-Primary-500, #d2042d) !important;\n}\n.multiple-campaigns-cart-button-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #ffffff;\n}\n.segements-campaigns-actions-row {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n\n.campaigns-table .ant-table-tbody > tr {\n  cursor: pointer;\n}\n\n.campaigns-table.ant-table-wrapper\n  .ant-table-tbody\n  .ant-table-row.ant-table-row-selected\n  > .ant-table-cell {\n  background: #fff !important;\n}\n.campaigns-table.ant-table-row.ant-table-row-selected\n  td\n  .ant-checkbox-disabled {\n  background-color: #f5f5f5 !important;\n}\n\n.campaigns-table.ant-checkbox-disabled .ant-checkbox-inner {\n  background: rgba(0, 0, 0, 0.04) !important;\n  border-color: #d9d9d9 !important;\n}\n\n@media (max-width: 1440px) {\n  .search-input {\n    width: 458px !important;\n  }\n\n  .campaign-utility {\n    margin-top: 14px;\n    margin-right: 30px !important;\n  }\n  .campaign-segments {\n    color: #000;\n    font-size: var(--Font-Font-Size-p, 16px);\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    height: 51px;\n    width: 1100px;\n    overflow-x: scroll;\n  }\n  .segment-container .ant-segmented.ant-segmented-sm .ant-segmented-item {\n    border-radius: 10px;\n    width: 200px;\n  }\n  .ant-segmented.ant-segmented-sm .ant-segmented-item-label {\n    min-height: 20px;\n    line-height: 20px;\n    width: 200px;\n    padding: 0 7px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .my-campaigns-container {\n    margin-inline: 30px;\n  }\n\n  .campaigns-table {\n    color: #fff;\n    width: 1600px;\n    height: 141px;\n    top: 275px;\n    left: 88px;\n    gap: 14px;\n    border-radius: 10px 0px 0px 0px;\n    opacity: 0px;\n  }\n\n  .my-campaigns-container .search-input {\n    width: 100% !important;\n  }\n  .campaign-search {\n    width: 170px;\n    height: 50px;\n    margin-left: 0px;\n  }\n\n  .quantity {\n    font-family: Roboto;\n    color: #000;\n    font-size: var(--Font-Font-Size-small, 13px);\n    font-weight: 500;\n  }\n\n  .campaign-utility {\n    margin-top: 17px;\n    margin-right: 0px !important;\n  }\n\n  .segment-container {\n    width: 1000px !important;\n    overflow-x: scroll;\n  }\n\n  .ant-table table {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 768px) {\n  .my-campaigns-container {\n    margin-inline: 30px;\n  }\n\n  .my-campaigns-container .search-input {\n    width: 100% !important;\n    border: none;\n  }\n\n  .quantity {\n    font-family: Roboto;\n    color: #000;\n    font-size: var(--Font-Font-Size-small, 13px);\n    font-weight: 500;\n    /* margin-left: 49%; */\n  }\n  .warning-icon-for-product-sold {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n  .mobile-dashboard-icons-card {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .campaign-cost {\n    font-family: Roboto;\n    font-size: 19px;\n    display: flex;\n    justify-content: end;\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n  }\n\n  .ellipsis-mobile-btn {\n    display: flex;\n    width: 51px;\n    height: 50px;\n    padding: 3px 7px;\n    justify-content: center;\n    align-items: center;\n    border: none;\n    border-radius: 5px;\n    background: #f5f5f5;\n  }\n\n  .mobile-campaign-card {\n    margin-top: 22px;\n  }\n\n  .product-align {\n    text-align: end;\n  }\n  .segment-container .ant-segmented.ant-segmented-sm .ant-segmented-item {\n    border-radius: 10px;\n    width: 210px;\n  }\n  .ant-segmented.ant-segmented-sm .ant-segmented-item-label {\n    min-height: 20px;\n    line-height: 20px;\n    width: 200px;\n    padding: 0 7px;\n  }\n  .number-of-products-version-col {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    align-content: flex-end;\n    justify-content: center;\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 576px) {\n  .my-campaign {\n    font-size: 19px;\n    margin: 25px 0 22px 18px;\n  }\n\n  .ellipse-container .rotate-ellipsis {\n    transform: rotate(90deg) !important;\n    width: 40px;\n    height: 40px;\n  }\n\n  .my-campaigns-container {\n    margin-inline: 16px;\n  }\n\n  .action-item {\n    color: #d2042d !important;\n  }\n\n  .ellipsis-btn {\n    display: flex;\n    height: 40px;\n    padding: 5px 3px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n  }\n\n  .ant-table-column-sorter {\n    color: #fff !important;\n  }\n\n  .ant-table-column-sorters {\n    display: inline !important;\n  }\n\n  .ant-table-column-sorter-inner {\n    flex-direction: row !important;\n  }\n\n  @media (max-width: 576px) {\n    .my-campaign {\n      font-size: 19px;\n      margin: 25px 0 22px 18px;\n    }\n\n    .search-input {\n      width: 100%;\n    }\n\n    .campaign-search {\n      margin-top: 22px;\n    }\n\n    .my-campaigns-container {\n      margin-left: 18px;\n    }\n\n    .campaign-utility {\n      margin-top: 22px;\n      margin-right: 18px;\n    }\n\n    .mobile-card {\n      margin-top: 17px;\n      margin-left: 30px;\n    }\n    .campaign-button {\n      width: 358px;\n      height: 50px;\n    }\n\n    .button-container {\n      display: flex;\n      width: 430px;\n      padding: 25px 18px 33px 18px;\n      justify-content: center;\n      align-items: center;\n      background: #fff;\n      box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.21);\n    }\n\n    .new-campaign {\n      position: \"sticky\";\n      bottom: \"0\";\n    }\n\n    .segment-container {\n      display: flex;\n      overflow-x: auto;\n      white-space: nowrap;\n      max-width: 100%;\n      width: 600px;\n      overflow-x: scroll;\n    }\n\n    .mobile-campaign-card {\n      margin-top: 22px;\n    }\n\n    .campaign-cost {\n      font-family: Roboto;\n      font-size: 19px;\n      display: flex;\n      justify-content: end;\n      color: var(--Colors-Text-500, #0a0f0d);\n      font-style: normal;\n      font-weight: 700;\n      line-height: normal;\n    }\n\n    .detail-block {\n      display: flex;\n      justify-content: space-between;\n    }\n\n    .mobile-campaign-card .detail-label {\n      color: #8e9190;\n      font-size: 13px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      margin-top: 30px;\n    }\n\n    .product-align {\n      text-align: end;\n    }\n\n    .quantity {\n      font-family: Roboto;\n      margin-left: 29%;\n    }\n\n    .dates {\n      color: #000;\n    }\n\n    .add-cart-button {\n      font-family: Roboto;\n      display: flex;\n      color: #fff !important;\n      width: 288px;\n      height: 50px;\n      padding: 8px 20px;\n      justify-content: center;\n      align-items: center;\n      border-radius: 10px;\n    }\n  }\n\n  .my-campaigns-container .fixed-addto-create-campaign-btn-card {\n    position: fixed;\n    display: flex;\n    width: 380px;\n    padding: 15px 18px 13px 18px;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.21);\n  }\n\n  .my-campaigns-container .new-campaign-creation {\n    display: flex;\n    width: 364px;\n    height: 50px;\n    border-radius: 5px;\n    background: #d2042d;\n    padding: 8px 20px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n  }\n\n  .my-campaigns-container\n    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n    background-color: #f5f5f5;\n    border: none;\n    height: 50px;\n    margin-top: 1rem;\n    color: rgb(12, 12, 12);\n  }\n}\n@media (max-width: 768px) {\n  .alignment-button-class {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n  }\n}\n@media (max-width: 430px) {\n  .detail-block .product-availability {\n    font-family: Roboto;\n    font-size: 14px;\n  }\n  .fixed-addto-create-campaign-btn-card\n    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n    background-color: #f5f5f5;\n    border: none;\n    height: 50px;\n    color: rgb(12, 12, 12);\n  }\n\n  .add-cart-button {\n    display: flex;\n    width: 275px;\n    height: 50px;\n    padding: 8px 20px;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n  }\n\n  .quantity {\n    font-family: Roboto;\n    margin-left: 15% !important;\n  }\n  .product-sold-status-row {\n    display: flex;\n    align-items: center !important;\n  }\n  .campaign-purchase-sold-icon-version {\n    margin-right: 5px;\n    font-size: 10px;\n    width: 20px !important;\n    height: 20px !important;\n  }\n}\n@media (max-width: 400px) {\n  .add-cart-button {\n    width: 233px;\n  }\n  .detail-block .product-availability {\n    font-family: Roboto;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 380px) {\n  .add-cart-button {\n    display: flex;\n    width: 200px;\n    height: 50px;\n    padding: 8px 20px;\n    justify-content: center;\n    align-items: center;\n    border-radius: 10px;\n  }\n  .handle-rename-cancel-btn {\n    display: flex;\n    width: 130px;\n    height: 40px;\n  }\n  .handle-rename-save-btn {\n    display: flex;\n    width: 130px;\n    height: 40px;\n    background-color: #d2042d;\n  }\n  .mobile-campaign-card .detail-label {\n    color: var(--Colors-Text-200, #8e9190);\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  }\n\n  .quantity {\n    font-family: Roboto;\n    margin-left: 30% !important;\n  }\n\n  .my-campaigns-container .fixed-addto-create-campaign-btn-card {\n    position: fixed;\n    display: flex;\n    width: 350px;\n    padding: 15px 18px 13px 18px;\n    justify-content: center;\n    align-items: center;\n    box-shadow: 0px -2px 30px 0px rgba(0, 0, 0, 0.21);\n  }\n\n  .my-campaigns-container\n    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n    background-color: #f5f5f5;\n    border: none;\n    height: 50px;\n    margin-top: 1rem;\n    color: rgb(12, 12, 12);\n  }\n\n  .my-campaigns-container .new-campaign-creation {\n    display: flex;\n    width: 364px;\n    height: 50px;\n    border-radius: 5px;\n    background: #d2042d;\n    padding: 8px 20px;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n  }\n\n  .fixed-addto-create-campaign-btn-card\n    .ant-btn-variant-outlined:not(:disabled):not(.ant-btn-disabled):hover {\n    background-color: #f5f5f5;\n    border: none;\n    height: 50px;\n    color: rgb(12, 12, 12);\n  }\n}\n@media (width <= 330px) {\n  .share-campaign-model-warn .share-campaign-text {\n    width: 100%;\n    flex-shrink: 0;\n    color: var(--Colors-Primary-500, #d2042d);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  }\n  .share-camapign-model-header {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-family: \"Montserrat\";\n    font-size: var(--Font-Font-Size-h5, 20px);\n    padding-bottom: 30px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
